export const environment = {
  production: true,
  backendUrl: 'https://www.pixtar.ae:5001',
  baseUrl: 'https://www.pixtar.ae',
  recaptcha_key: '6Le_lT4cAAAAAK9VEk4nEBoKy0ydYrE-P9A_wj2U'
};
